import { gql } from 'graphql-request'

export const LOGIN_WITH_LINE = gql`
  mutation LoginWithLine($loginWithLineInput: LoginWithLineInput!) {
    loginWithLine(loginWithLineInput: $loginWithLineInput) {
      token
    }
  }
`
